import e from 'cors';
import React, { useState, useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';
import CurrencyInput from 'react-currency-input-field';
import '/src/components/pdp/style/pdp.css'
import './investmentCalculator.css'
import { Row } from 'react-bootstrap';
import DisclaimerModal from './DisclaimerModal';
import { trackButtonClick, trackEvent } from '@/utils/analytics';

const InvestmentCalculator = ({isForeclosure}) => {
  const [investmentData, setInvestmentData] = useState();
  const [rentAmount, setRentAmount] = useState();
  const [vacancyAmount, setVacancyAmount] = useState();
  const [vacancyRate, setVacancyRate] = useState(0);
  const [selectedTab, setSelectedTab] = useState("Purchase");
  const latestBidCenterData = useSelector(state => state.pdp?.latestBidCenterData);
  const pdpInitData = useSelector(state => state.pdp?.pdpInitData);
  const bidCenterData = useSelector(state => state.pdp?.bidCenterData);
  const [showBanner, setShowBanner] = useState(false);

  const [offerPrice, setOfferPrice] = useState(
    pdpInitData?.propertyDetails?.commonAttributes.status === 'ACTV'
      ? latestBidCenterData?.nextpossibleBidAmount
      : pdpInitData?.propertyDetails?.commonAttributes?.status === 'SPND'
        ? bidCenterData?.highestBidAmount
        : pdpInitData?.propertySpecialDetails?.listingPrice,
  );
  // let maintanance = '';
  // let hoeFee = ''
  // let propertyManagement = '';
  // let taxes = '';
  // let insurance = '';


  const [maintanance, setMaintanance] = useState('');
  const [hoeFee, setHoeFee] = useState(0);
  const [propertyManagement, setPropertyManagement] = useState();
  const [taxes, setTaxes] = useState();
  const [insurance, setInsurance] = useState();
  const [purchasePrice, setPurchasePrice] = useState(offerPrice);
  const [rehabPercentage, setRehabPercentage] = useState();
  const [rehabVal, setRehabVal] = useState();
  const [closingCost, setClosingCost] = useState();
  const [closingCostPercentage, setClosingCostPercentage] = useState();
  //FinanceTab
  const [downPayment, setDownPayment] = useState();
  const [downPaymentError, setDownPaymentError] = useState();
  const [downPaymentPercent, setDownPaymentPercent] = useState(20);
  const [interstRate, setInterstRate] = useState('2.5');
  const [financeTotal, setFinanceTotal] = useState();
  const [monthlyPayment, setMonthlyPayment] = useState();
  const [monthlyExpense, setMonthlyExpenses] = useState();
  const [yearlyExpenses, setYearlyExpenses] = useState();
  const [monthlyIncome, setMonthlyIncome] = useState();
  const [yearlyIncome, setYearlyIncome] = useState();
  const [capitalInvestment, setCapitalInvestment] = useState();
  const [needClosingAT, setNeedClosingAT] = useState();
  const [grossYield, setGrossYield] = useState();
  const [netYield, setNetYield] = useState();
  const [monthlyCasFlow, setMonthlyCasFlow] = useState();
  const [firstTime, setFirstTime] = useState(true);
  const [shouldShowCollapseView, setShouldShowCollapseView] = useState(false);
  const [vaccanyError, setVaccanyError] = useState(false);
  const [closingCostError, setClosingCostError] = useState(false);
  const [customYear, setCustomYear] = useState('');
  const [rangeDisabled, setRangeDisabled] = useState(false);
  const [selectedYear, setSelectedYear] = useState(30);
  const [shouldShowInvstLoader, setShouldShowInvstLoader] = useState(true);
  const [initialOfferP, setInitialOfferP] = useState(
    pdpInitData?.propertyDetails?.commonAttributes?.status === 'ACTV'
      ? bidCenterData?.nextpossibleBidAmount
      : pdpInitData?.propertyDetails?.commonAttributes?.status === 'SPND'
        ? bidCenterData?.highestBidAmount
        : pdpInitData?.propertySpecialDetails?.listingPrice,
  );
  // var rentAmt = rentAmount;
  const [rentAmt, setRentAmt] = useState();
  const [vaccyRateSlider, setVaccyRateSilder] = useState();
  const [offerPSlider, setOfferPSlider] = useState();
  const [rehabValSlider, setRehabValSlider] = useState();
  const [closingCSlider, setClosingCSlider] = useState();
  const [irSlider, setIRSlider] = useState('2.5');
  const [downpaymentSlider, setDownpaymentSlider] = useState(20);
  const [maintananceSlider, setMaintananceSlider] = useState('');
  const [hoeSlider, setHoeSlider] = useState();
  const [propertyManagementSlider, setPropertyManagementSlider] = useState();
  const [taxesSlider, setTaxesSlider] = useState();
  const [insuranceSlider, setInsuranceSlider] = useState();
  const [latestRes, setLatestRes] = useState();
  const [isDataInit, setIsDataInit] = useState(false);
  const investmentInitData = useSelector(state => state.pdp?.investmentInitData);


  const updateSliderVisual = (slider) => {
    const value = ((slider.value - slider.min) / (slider.max - slider.min)) * 100;
    slider.style.setProperty('--value', `${value}%`);
  };

  useEffect(() => {
    const sliders = document.querySelectorAll('.ic-range');
    sliders.forEach(slider => {
      slider.addEventListener('input', () => updateSliderVisual(slider));
      updateSliderVisual(slider); // initialize
    });
    return () => {
      sliders.forEach(slider => {
        slider.removeEventListener('input', () => updateSliderVisual(slider));
      });
    };
  }, []);

  const handleGAEvents = (name) => {
    // Call sites pass a descriptive string like
    // "InvestmentCalculator|<Section>|<Field>" (e.g. "InvestmentCalculator|Finance|DownPaymentSlider").
    // The full string exceeds GA4's 40-char event-name limit, so we emit a short
    // fixed name and move the section/field/input_type detail into event params.
    const parts = typeof name === "string" ? name.split("|") : [];
    const isCalcInput = parts[0] === "InvestmentCalculator" && parts.length >= 3;

    const eventName = isCalcInput ? "investment_calculator_input" : name;

    let calcParams = {};
    if (isCalcInput) {
      const section = parts[1] || "";
      const field = parts.slice(2).join("|");
      const inputType = /Slider$/.test(field)
        ? "slider"
        : /Percentage$/.test(field)
        ? "percentage"
        : "input";
      calcParams = {
        section: section
          .replace(/([a-z])([A-Z])/g, "$1_$2")
          .toLowerCase(),
        field: field.replace(/([a-z])([A-Z])/g, "$1_$2").toLowerCase(),
        input_type: inputType,
        listing_id: pdpInitData?.propertyDetails?.listingId,
        foreclosure_property: isForeclosure ? "yes" : "no",
        status: pdpInitData?.propertyDetails?.commonAttributes?.status,
      };
    }

    trackEvent({
      name: eventName,
      category: "NEW-PDP",
      eventLabel: `${pdpInitData?.propertyDetails?.propertyId}|${
        pdpInitData?.propertyDetails?.listingId
      }|${pdpInitData?.propertyDetails?.address?.streetNumber} ${
        pdpInitData?.propertyDetails?.address?.streetName
      }, ${pdpInitData?.propertyDetails?.address?.county}, ${
        pdpInitData?.propertyDetails?.address?.city
      }, ${pdpInitData?.propertyDetails?.address?.state}, ${
        pdpInitData?.propertyDetails?.address?.zip
      }|Referrer: Other|Foreclosure Property:${
        isForeclosure ? "Yes" : "No"
      }|Status:${pdpInitData?.propertyDetails?.commonAttributes?.status}`,
      ...(isCalcInput ? { eventParams: calcParams } : {}),
    });
  };

  const tempSetData = () => {

    if (investmentInitData !== null && isDataInit === false) {
      setIsDataInit(true);
      setShouldShowInvstLoader(false);

      if (
        investmentInitData.response?.data_record?.calculator_fields
          ?.rent_med_mo &&
        investmentInitData.response?.data_record?.calculator_fields
          ?.vacancy_rate &&
        investmentInitData.response?.data_record?.calculator_fields
          ?.rent_low_mo &&
        investmentInitData.response?.data_record?.calculator_fields
          ?.rent_high_mo &&
        investmentInitData.response?.data_record?.calculator_fields
          ?.listingprice &&
        investmentInitData.response?.data_record?.calculator_fields
          ?.listingprice !== '-'
      ) {
        var offerP =
          pdpInitData?.propertyDetails?.commonAttributes?.status === 'ACTV'
            ? latestBidCenterData?.nextpossibleBidAmount
            : pdpInitData?.propertyDetails?.commonAttributes?.status === 'SPND'
              ? bidCenterData?.highestBidAmount
              : Number(
                investmentInitData.response?.data_record?.calculator_fields
                  ?.listingprice,
              );


        if (offerP === 0) {
          offerP = Number(
            investmentInitData.response?.data_record?.calculator_fields
              ?.listingprice,
          );
        }
        setInvestmentData(
          investmentInitData?.response?.data_record?.calculator_fields,
        );
        setInitialData(
          investmentInitData?.response?.data_record?.calculator_fields,
          offerP,
        );
      }
    }
  }
  useEffect(() => {
    if (investmentInitData !== null) {
      setShouldShowInvstLoader(false);
      if (
        investmentInitData.response?.data_record?.calculator_fields
          ?.rent_med_mo &&
        investmentInitData.response?.data_record?.calculator_fields
          ?.vacancy_rate &&
        investmentInitData.response?.data_record?.calculator_fields
          ?.rent_low_mo &&
        investmentInitData.response?.data_record?.calculator_fields
          ?.rent_high_mo &&
        investmentInitData.response?.data_record?.calculator_fields
          ?.listingprice &&
        investmentInitData.response?.data_record?.calculator_fields
          ?.listingprice !== '-'
      ) {
        var offerP =
          pdpInitData?.propertyDetails?.commonAttributes?.status === 'ACTV'
            ? latestBidCenterData?.nextpossibleBidAmount
            : pdpInitData?.propertyDetails?.commonAttributes?.status === 'SPND'
              ? latestBidCenterData?.highestBidAmount
              : Number(
                investmentInitData.response?.data_record?.calculator_fields
                  ?.listingprice,
              );

        if (offerP === 0 || offerP === undefined) {
          offerP = Number(
            investmentInitData.response?.data_record?.calculator_fields
              ?.listingprice,
          );
        }


        console.log('ldfsd', investmentInitData.response?.data_record?.calculator_fields
          ?.listingprice,);

        setInvestmentData(
          investmentInitData?.response?.data_record?.calculator_fields,
        );
        setInitialData(
          investmentInitData?.response?.data_record?.calculator_fields,
          offerP,
        );
      }
    }
  }, [investmentInitData]);

  const updateRentAmount = rentData => {
    setRentAmount(Number(rentData));
    setRentAmt(Number(rentData));
    const vaccyAmt = (Number(rentData) * Number(vacancyRate)) / 100;
    setVacancyAmount(vaccyAmt?.toFixed(2));
    const income = Number(rentData) - Number(vaccyAmt);
    setMonthlyIncome(income?.toFixed(2));
    const annIncome = Number(income) * 12;
    setYearlyIncome(annIncome?.toFixed(2));
    var gross = (annIncome / offerPrice) * 100;
    gross = isNaN(gross) ? 0 : gross;
    setGrossYield(gross?.toFixed(2));
    var net = ((annIncome - yearlyExpenses) / offerPrice) * 100;
    net = isNaN(net) ? 0 : net;
    setNetYield(net?.toFixed(2));
    var cash = annIncome - yearlyExpenses - monthlyPayment * 12;
    var cashVal = cash / 12;
    setMonthlyCasFlow(cashVal?.toFixed(2));
  };
  const setInitialData = (data, offerP) => {
    setOfferPrice(offerP);
    setOfferPSlider(offerP);
    setInitialOfferP(offerP);
    const vacancyLoss =
      (Number(data?.rent_med_mo) * parseFloat(data?.vacancy_rate)) / 100;
    setVacancyAmount(vacancyLoss?.toFixed(2));
    setVacancyRate(data?.vacancy_rate?.toFixed(2));
    setVaccyRateSilder(data?.vacancy_rate?.toFixed(2));
    setRentAmount(Number(data?.rent_med_mo));
    setRentAmt(Number(data?.rent_med_mo));
    const vaccyAmt =
      (Number(data?.rent_med_mo) * Number(data?.vacancy_rate)) / 100;
    setVacancyAmount(vaccyAmt?.toFixed(2));
    const income = Number(data?.rent_med_mo) - Number(vaccyAmt);
    setMonthlyIncome(income?.toFixed(2));
    const annIncome = Number(income) * 12;
    setYearlyIncome(annIncome?.toFixed(2));
    const mntAmnt =
      data?.property_maintenance_mo !== null
        ? Number(data?.property_maintenance_mo)?.toFixed(2)
        : 0;
    const hoeAmnt =
      data?.derived_monthly_hoa_val !== null
        ? Number(data?.derived_monthly_hoa_val)?.toFixed(2)
        : 0;
    const mngmtAmnt =
      data?.property_management_mo !== null
        ? Number(data?.property_management_mo)?.toFixed(2)
        : 0;
    const isrnceAmnt =
      data?.property_insurance_mo !== null
        ? Number(data?.property_insurance_mo)?.toFixed(2)
        : 0;
    const taxAmnt =
      data?.property_taxes_mo !== null
        ? Number(data?.property_taxes_mo)?.toFixed(2)
        : 0;
    const monthlyExp =
      Number(mntAmnt) +
      Number(hoeAmnt) +
      Number(mngmtAmnt) +
      Number(isrnceAmnt) +
      Number(taxAmnt);
    const yearlyExp = monthlyExp * 12;
    setMonthlyExpenses(monthlyExp?.toFixed(2));
    setYearlyExpenses(yearlyExp?.toFixed(2));
    setMaintanance(Number(data?.property_maintenance_mo));
    setMaintananceSlider(Number(data?.property_maintenance_mo));
    setHoeFee(Number(data?.derived_monthly_hoa_val));
    setHoeSlider(Number(data?.derived_monthly_hoa_val)?.toFixed(2));
    setPropertyManagement(data?.property_management_mo);
    setPropertyManagementSlider(data?.property_management_mo);
    setTaxes(data?.property_taxes_mo?.toFixed(2));
    setTaxesSlider(data?.property_taxes_mo?.toFixed(2));
    setInsurance(Number(data?.property_insurance_mo));
    setInsuranceSlider(Number(data?.property_insurance_mo));
    // setPurchaseData(offerPrice);
    // setPurchasePrice(offerPrice);
    let dPay = (offerP * 20) / 100;
    var financetotal = parseFloat(offerP) - parseFloat(dPay);
    setPurchasePrice(offerP);
    var rehabval = Number(data?.rehab_cost_estimate_1x) || 0;
    setRehabVal(rehabval);
    var rehabpercentage = (rehabval && (rehabval / offerP) * 100) || 0;
    setRehabPercentage(rehabpercentage?.toFixed(2));
    setRehabValSlider(rehabpercentage?.toFixed(2));
    var closingCostVal = (offerP * 2) / 100;
    setClosingCost(parseFloat(closingCostVal?.toFixed(2)));
    var closingCostP = (closingCostVal / offerP) * 100;
    setClosingCostPercentage(closingCostP?.toFixed(2));
    setClosingCSlider(closingCostP?.toFixed(2));
    var capitalInvVal =
      Number(offerP) + Number(rehabval) + Number(closingCostVal);
    // if (isNaN(CapitalInvestVal)) {
    //   CapitalInvestVal = 0;
    // }
    setCapitalInvestment(capitalInvVal ? capitalInvVal?.toFixed(2) : 0);
    var neededClosingVal = parseFloat(dPay) + parseFloat(closingCostVal);
    if (isNaN(neededClosingVal)) {
      neededClosingVal = 0;
    }
    setNeedClosingAT(neededClosingVal?.toFixed(2));
    setDownPayment(dPay);
    setFinanceTotal(financetotal?.toFixed(2));
    var interest = parseFloat(interstRate) / 100 / 12;
    var payment = -getMonthyPayment(
      interest,
      selectedYear * 12,
      financetotal,
      0,
    );
    setMonthlyPayment(Number(payment)?.toFixed(2));
    const monthlyP = payment?.toFixed(2);
    var gross = (Number(annIncome?.toFixed(2)) / Number(offerP)) * 100;
    gross = isNaN(gross) ? 0 : gross;
    setGrossYield(gross?.toFixed(2));
    var net = ((annIncome - yearlyExp) / offerP) * 100;

    net = isNaN(net) ? 0 : net;
    setNetYield(net?.toFixed(2));
    var cash = annIncome - yearlyExp - monthlyP * 12;
    var cashVal = cash / 12;
    setMonthlyCasFlow(cashVal?.toFixed(2));
    // calculateGrossOutput();
    console.log(offerPrice);
    console.log(purchasePrice);
  };
  // const setVacancyLossData = (amount, rate) => {
  //   const vacancyLoss = (Number(amount) * parseFloat(rate)) / 100;
  //   setVacancyAmount(vacancyLoss);
  //   setVacancyRate(rate.toFixed(2));
  //   const income = Number(rentAmount) - Number(vacancyLoss);
  //   setMonthlyIncome(income.toFixed(2));
  //   const annIncome = Number(income) * 12;
  //   setYearlyIncome(annIncome.toFixed(2));
  //   calculateGrossOutput();
  //   console.log('vacancyAmount ***** 222', vacancyAmount);

  // };
  const updateVacancyRate = vAmount => {
    const vRate = (Number(vAmount) / Number(rentAmount)) * 100;
    setVacancyAmount(vAmount);
    if (vAmount > rentAmount) {
      setVaccanyError(true);
    } else {
      setVacancyRate(vRate ? vRate?.toFixed(2) : 0);
      setVaccyRateSilder(vRate ? vRate?.toFixed(2) : 0);
      const income = Number(rentAmount) - Number(vAmount);
      setMonthlyIncome(income?.toFixed(2));
      const annIncome = Number(income) * 12;
      setYearlyIncome(annIncome?.toFixed(2));

      var gross = (annIncome / offerPrice) * 100;
      gross = isNaN(gross) ? 0 : gross;
      setGrossYield(gross?.toFixed(2));
      var net = ((annIncome - yearlyExpenses) / offerPrice) * 100;
      net = isNaN(net) ? 0 : net;
      setNetYield(net?.toFixed(2));
      var cash = annIncome - yearlyExpenses - monthlyPayment * 12;
      var cashVal = cash / 12;
      setMonthlyCasFlow(cashVal?.toFixed(2));
    }
  };
  const updateVacancyAmount = rate => {
    const vacancyLoss =
      (Number(rentAmount) * parseFloat(rate > 0 ? rate : 0)) / 100;
    setVacancyAmount(vacancyLoss?.toFixed(2));

    const income = Number(rentAmount) - Number(vacancyLoss);
    setMonthlyIncome(income?.toFixed(2));
    const annIncome = Number(income) * 12;
    setYearlyIncome(annIncome?.toFixed(2));

    var gross = (annIncome / offerPrice) * 100;
    gross = isNaN(gross) ? 0 : gross;
    setGrossYield(gross?.toFixed(2));
    var net = ((annIncome - yearlyExpenses) / offerPrice) * 100;
    net = isNaN(net) ? 0 : net;
    setNetYield(net?.toFixed(2));
    var cash = annIncome - yearlyExpenses - monthlyPayment * 12;
    var cashVal = cash / 12;
    setMonthlyCasFlow(cashVal?.toFixed(2));
  };
  // const getFormattedPrice = amount => {
  //   if ((amount?.length === 0) || isNaN(amount)) {
  //     return '';
  //   }
  //   return `$${amount?.toString().replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,')}`;
  // };


  const getFormattedPrice = amount => {
    const num = Math.round(Number(amount));
    if (isNaN(num)) return '';
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
      minimumFractionDigits: 0,
      maximumFractionDigits: 0
    }).format(num);
  };

  const updatePurchaseData = amount => {
    setOfferPrice(amount);
    setPurchasePrice(amount);
    let dPay = (amount * downPaymentPercent) / 100;
    setDownPayment(dPay);
    var rehabval = Number(amount * rehabPercentage) / 100;
    setRehabVal(rehabval?.toFixed(2));
    setRehabValSlider(rehabPercentage);

    var closingCostVal = ((amount * closingCostPercentage) / 100)?.toFixed(2);
    setClosingCost(parseFloat(closingCostVal)?.toFixed(2));

    if (parseFloat(closingCostVal)?.toFixed(2) > Number(amount)) {
      setClosingCostError(true);
    } else {
      setClosingCostError(false);
    }

    var neededClosingVal = parseFloat(dPay) + parseFloat(closingCostVal);
    if (isNaN(neededClosingVal)) {
      neededClosingVal = 0;
    }
    setNeedClosingAT(neededClosingVal?.toFixed(2));
    var CapitalInvestVal =
      parseFloat(amount) + parseFloat(rehabval) + parseFloat(closingCostVal);
    if (isNaN(CapitalInvestVal)) {
      CapitalInvestVal = 0;
    }
    setCapitalInvestment(CapitalInvestVal?.toFixed(2));

    var financetotal = parseFloat(amount) - parseFloat(dPay);

    setFinanceTotal(financetotal?.toFixed(2));
    const rate = interstRate.length > 0 ? parseFloat(interstRate) : 0;
    var interest = rate / 100 / 12;
    var payment = -getMonthyPayment(
      interest,
      selectedYear * 12,
      financetotal,
      0,
    );

    // var monthlyPay = parseFloat(financeTotal) * [ interstRate/12*(1 + interstRate/12)^120 ] / [ (1 + interstRate/12)^120 - 1];
    setMonthlyPayment(payment?.toFixed(2));
    // calculateGrossOutput();

    const income = Number(rentAmount) - Number(vacancyAmount);
    setMonthlyIncome(income?.toFixed(2));
    const annIncome = Number(income) * 12;
    setYearlyIncome(annIncome?.toFixed(2));
    var gross = (annIncome / amount) * 100;
    gross = isNaN(gross) ? 0 : gross;
    setGrossYield(gross?.toFixed(2));
    var net = ((annIncome - yearlyExpenses) / amount) * 100;
    net = isNaN(net) ? 0 : net;
    setNetYield(net?.toFixed(2));
    var cash = annIncome - yearlyExpenses - payment * 12;
    var cashVal = cash / 12;
    setMonthlyCasFlow(cashVal?.toFixed(2));
  };
  const calculateRehabPercentage = amount => {
    if (offerPrice > 0 && amount <= offerPrice) {
      var rehabpercentage = (amount && (amount / offerPrice) * 100) || 0;
      setRehabVal(amount);
      setRehabValSlider(rehabpercentage);
      setRehabPercentage(rehabpercentage?.toFixed(2));
      calculateGrossOutput();
      var CapitalInvestVal =
        parseFloat(offerPrice) + parseFloat(amount) + parseFloat(closingCost);
      if (isNaN(CapitalInvestVal)) {
        CapitalInvestVal = 0;
      }
      setCapitalInvestment(CapitalInvestVal?.toFixed(2));
    }
  };
  const calculateRehabValue = rPercent => {
    var rehabval = (rPercent && (rPercent * offerPrice) / 100) || 0;
    setRehabVal(rehabval?.toFixed(2));
    setRehabPercentage(rPercent);

    calculateGrossOutput();
    var CapitalInvestVal =
      parseFloat(offerPrice) + parseFloat(rehabval) + parseFloat(closingCost);
    if (isNaN(CapitalInvestVal)) {
      CapitalInvestVal = 0;
    }
    setCapitalInvestment(CapitalInvestVal?.toFixed(2));
  };
  const calculateClosingCostPercentage = amount => {
    if (offerPrice > 0 && amount <= offerPrice) {
      var closingCostP = (amount / offerPrice) * 100;
      setClosingCost(amount ? parseFloat(amount) : 0);
      setClosingCostPercentage(closingCostP?.toFixed(2));
      setClosingCSlider(closingCostP?.toFixed(2));

      var neededClosingVal = parseFloat(downPayment) + parseFloat(amount);
      if (isNaN(neededClosingVal)) {
        neededClosingVal = 0;
      }
      setNeedClosingAT(neededClosingVal?.toFixed(2));
      var CapitalInvestVal =
        parseFloat(offerPrice) + parseFloat(rehabVal) + parseFloat(amount);
      if (isNaN(CapitalInvestVal)) {
        CapitalInvestVal = 0;
      }
      setCapitalInvestment(CapitalInvestVal?.toFixed(2));
    }
  };
  const calculateClosingCost = ccp => {
    var closingCostAmt = (offerPrice * ccp) / 100;
    setClosingCost(parseFloat(closingCostAmt?.toFixed(2)));
    setClosingCostPercentage(ccp);

    var neededClosingVal = parseFloat(downPayment) + parseFloat(closingCostAmt);
    if (isNaN(neededClosingVal)) {
      neededClosingVal = 0;
    }
    setNeedClosingAT(neededClosingVal?.toFixed(2));
    var CapitalInvestVal =
      parseFloat(offerPrice) +
      parseFloat(rehabVal) +
      parseFloat(closingCostAmt);
    if (isNaN(CapitalInvestVal)) {
      CapitalInvestVal = 0;
    }
    setCapitalInvestment(CapitalInvestVal?.toFixed(2));
  };
  const calculateGrossOutput = amount => {
    const income = Number(rentAmount) - Number(vacancyAmount);
    setMonthlyIncome(income?.toFixed(2));
    const annIncome = Number(income) * 12;
    setYearlyIncome(annIncome?.toFixed(2));
    var gross = (annIncome / offerPrice) * 100;
    gross = isNaN(gross) ? 0 : gross;
    setGrossYield(gross?.toFixed(2));
    var net = ((annIncome - yearlyExpenses) / offerPrice) * 100;
    net = isNaN(net) ? 0 : net;
    setNetYield(net?.toFixed(2));
    var cash = annIncome - yearlyExpenses - monthlyPayment * 12;
    var cashVal = cash / 12;
    setMonthlyCasFlow(cashVal?.toFixed(2));
  };
  const getMonthyPayment = (ir, np, pv, fv, type) => {
    /*
     * ir   - interest rate per month
     * np   - number of periods (months)
     * pv   - present value
     * fv   - future value
     * type - when the payments are due:
     *        0: end of the period, e.g. end of month (default)
     *        1: beginning of period
     */
    try {
      var pmt, pvif;

      fv || (fv = 0);
      type || (type = 0);

      if (ir === 0) {
        return -(pv + fv) / np;
      }

      pvif = Math.pow(1 + ir, np);
      pmt = (-ir * pv * (pvif + fv)) / (pvif - 1);

      if (type === 1) {
        pmt /= 1 + ir;
      }

      return pmt;
    } catch (error) {

    }
  };
  const calculateTotalFinanceInfo = (downpayment, iRate, sYear) => {
    if (downpayment <= offerPrice) {
      setDownPayment(downpayment);
      let percent = (downpayment / offerPrice) * 100;
      setDownPaymentPercent(percent?.toFixed(2));
      setDownpaymentSlider(percent?.toFixed(2));
      var financetotal = parseFloat(offerPrice) - parseFloat(downpayment);
      setFinanceTotal(financetotal?.toFixed(2));
      const rateI = iRate?.length > 0 ? parseFloat(iRate) : 0;

      var intR = iRate / 100 / 12;
      var payment = -getMonthyPayment(intR, sYear * 12, financetotal, 0);

      console.log('payment ', payment)
      if (payment === Infinity) {
        setMonthlyPayment(0);
      } else {
        setMonthlyPayment(payment?.toFixed(2));
      }

      // var monthlyPay = parseFloat(financeTotal) * [ interstRate/12*(1 + interstRate/12)^120 ] / [ (1 + interstRate/12)^120 - 1];

      const income = Number(rentAmount) - Number(vacancyAmount);
      setMonthlyIncome(income?.toFixed(2));
      const annIncome = Number(income) * 12;
      setYearlyIncome(annIncome?.toFixed(2));

      var gross = (annIncome / offerPrice) * 100;
      gross = isNaN(gross) ? 0 : gross;
      setGrossYield(gross?.toFixed(2));
      var net = ((annIncome - yearlyExpenses) / offerPrice) * 100;
      net = isNaN(net) ? 0 : net;
      setNetYield(net?.toFixed(2));
      var cash = annIncome - yearlyExpenses - payment * 12;
      var cashVal = cash / 12;
      setMonthlyCasFlow(cashVal?.toFixed(2));
    }
  };
  const calculateDownPayment = rate => {
    let dPay = (offerPrice * rate) / 100;
    var financetotal = parseFloat(offerPrice) - parseFloat(dPay);
    setDownPayment(dPay);
    setFinanceTotal(financetotal?.toFixed(2));
    var interest = parseFloat(interstRate) / 100 / 12;
    var payment = -getMonthyPayment(
      interest,
      selectedYear * 12,
      financetotal,
      0,
    );
    // var monthlyPay = parseFloat(financeTotal) * [ interstRate/12*(1 + interstRate/12)^120 ] / [ (1 + interstRate/12)^120 - 1];
    var neededClosingVal = parseFloat(dPay) + parseFloat(closingCost);
    if (isNaN(neededClosingVal)) {
      neededClosingVal = 0;
    }
    setNeedClosingAT(neededClosingVal?.toFixed(2));
    setMonthlyPayment(payment?.toFixed(2));

    const income = Number(rentAmount) - Number(vacancyAmount);
    setMonthlyIncome(income?.toFixed(2));
    const annIncome = Number(income) * 12;
    setYearlyIncome(annIncome?.toFixed(2));

    var gross = (annIncome / offerPrice) * 100;
    gross = isNaN(gross) ? 0 : gross;
    setGrossYield(gross?.toFixed(2));
    var net = ((annIncome - yearlyExpenses) / offerPrice) * 100;
    net = isNaN(net) ? 0 : net;
    setNetYield(net?.toFixed(2));
    var cash = annIncome - yearlyExpenses - payment * 12;
    var cashVal = cash / 12;
    setMonthlyCasFlow(cashVal?.toFixed(2));
  };
  const calculateGrossExpense = (amount, type) => {
    let monthlyExpences = 0;
    if (type === 'maintenance') {
      monthlyExpences =
        Number(amount) +
        Number(hoeFee) +
        Number(propertyManagement) +
        Number(taxes) +
        parseFloat(insurance);
    } else if (type === 'insurance') {
      monthlyExpences =
        Number(amount) +
        Number(hoeFee) +
        Number(propertyManagement) +
        Number(taxes) +
        Number(maintanance);
    } else if (type === 'hoeFee') {
      monthlyExpences =
        Number(amount) +
        Number(propertyManagement) +
        Number(taxes) +
        parseFloat(insurance) +
        Number(maintanance);
    } else if (type === 'management') {
      monthlyExpences =
        Number(amount) +
        Number(hoeFee) +
        Number(taxes) +
        parseFloat(insurance) +
        Number(maintanance);
    } else if (type === 'taxes') {
      monthlyExpences =
        Number(amount) +
        Number(hoeFee) +
        Number(propertyManagement) +
        parseFloat(insurance) +
        Number(maintanance);
    } else {
      monthlyExpences =
        Number(taxes) +
        Number(hoeFee) +
        Number(propertyManagement) +
        parseFloat(insurance) +
        Number(maintanance);
    }

    monthlyExpences = isNaN(monthlyExpences) ? 0 : monthlyExpences;
    setMonthlyExpenses(monthlyExpences?.toFixed(2));
    setYearlyExpenses((monthlyExpences * 12)?.toFixed(2));

    const yrExp = (monthlyExpences * 12)?.toFixed(2);

    const income = Number(rentAmount) - Number(vacancyAmount);
    setMonthlyIncome(income?.toFixed(2));
    const annIncome = Number(income) * 12;
    setYearlyIncome(annIncome?.toFixed(2));
    var gross = (annIncome / offerPrice) * 100;
    gross = isNaN(gross) ? 0 : gross;
    setGrossYield(gross?.toFixed(2));
    var net = ((annIncome - yrExp) / offerPrice) * 100;
    net = isNaN(net) ? 0 : net;
    setNetYield(net?.toFixed(2));
    var cash = annIncome - yrExp - monthlyPayment * 12;
    var cashVal = cash / 12;
    setMonthlyCasFlow(cashVal?.toFixed(2));
  };
  function charOccurances(str, char) {
    for (var c = 0, i = 0, len = str.length; i < len; ++i) {
      if (str[i] === char) {
        ++c;
      }
    }
    return c;
  }

  const loadFinancigSection = () => {
    return (
      <>
        <div className="ic-range-container">
          <div className="col-lg-6">
            <label htmlFor="ic-range-down-payment" className="ic-label">Down Payment</label>
            <input className="form-range ic-range"
              type="range"

              max={100}
              min={0}
              value={downpaymentSlider ? Number(downpaymentSlider) : 0}
              step={1}
              onPointerUp={() => handleGAEvents("InvestmentCalculator|Finance|DownPaymentSlider")}
              onChange={e => {
                setDownpaymentSlider(e.target.value);
                setDownPaymentError(false);
                setDownPaymentPercent(e.target.value);
                calculateDownPayment(Number(e.target.value));
              }}
              id="ic-range-down-payment"
            />
          </div>
          <div className="col-lg-6 d-flex">
            <CurrencyInput
              className="form-control mr10 ic-currency-text"
              placeholder=""
              aria-label="Down payment amount"
              type={'money'}
              prefix="$"
              numberOfLines={1}
              returnKeyType="done"
              maxLength={9}
              keyboardType={'numeric'}
              includeRawValueInChangeText={true}
              value={downPayment === 0 ? 0 : downPayment}
              onBlur={() => handleGAEvents("InvestmentCalculator|Finance|DownPaymentInput")}
              onValueChange={(value, name, values) => {
                if (value > offerPrice) {
                  setDownPaymentError(true);
                } else {
                  setDownPaymentError(false);
                }
                setDownPayment(value);
                calculateTotalFinanceInfo(value, interstRate, selectedYear);
              }}
            />
            <CurrencyInput type="text"
              className="form-control ic-currency-text-percentage"
              placeholder=""
              aria-label="Down payment percentage"
              suffix="%"
              keyboardType="numeric"
              returnKeyType="done"
              underlineColorAndroid="transparent"
              placeholderTextColor="#85929e"
              value={downPaymentPercent?.toString()}
              maxLength={4}
              onBlur={() => handleGAEvents("InvestmentCalculator|Finance|DownPaymentPercentage")}
              onValueChange={(value, name, values) => {

                if (value === '' || value === undefined) {
                  setDownPaymentPercent(0);
                  setDownpaymentSlider(0);
                  calculateDownPayment(0);
                  return;
                }

                // Allow partial input like "1.", "0.", etc.
                const regex = /^(\d{1,3})(\.\d*)?$/;

                if (regex.test(value)) {
                  console.log('value ', value);
                  const numericValue = parseFloat(value);

                  // Only update if value is <= 100
                  if (numericValue <= 100) {
                    setDownPaymentPercent(value);
                    setDownpaymentSlider(value);
                    calculateDownPayment(Number(value));
                  }
                }
              }}
            />
          </div>
        </div>

        <div style={{ paddingLeft: '50%', width: '100%' }}>
          {downPaymentError === true && (
            <p className='error-generic'>Amount should be less than offer amount</p>
          )}

        </div>
        <div className="ic-range-container">
          <div className="col-lg-6">
            <label htmlFor="ic-range-interest-rate" className="ic-label">Interest Rate</label>
            <input className="form-range ic-range"
              type="range"
              step={1} id="ic-range-interest-rate"
              max={100}
              min={0}
              maximumTrackTintColor="paleGrey"
              value={irSlider ? Number(irSlider) : 0}
              onPointerUp={() => handleGAEvents("InvestmentCalculator|Finance|InterestRateSlider")}
              onChange={e => {
                setIRSlider(e.target.value);
                setInterstRate(e.target.value);
                calculateTotalFinanceInfo(downPayment, e.target.value, selectedYear);
              }}
            />
          </div>
          <div className="col-lg-6">
            <CurrencyInput
              className="form-control ic-currency-text-percentage"
              placeholder=""
              aria-label="Interest rate percentage"
              type={'money'}
              suffix="%"
              numberOfLines={1}
              returnKeyType="done"
              maxLength={4}
              keyboardType={'numeric'}
              includeRawValueInChangeText={true}
              value={interstRate?.toString()}
              onFocus={event => { }}
              onBlur={() => handleGAEvents("InvestmentCalculator|Finance|InterestRatePercentage")}
              onValueChange={(value, name, values) => {
                // Allow empty string so user can delete
                if (value === '' || value === undefined) {
                  setInterstRate(0);
                  setIRSlider(0);
                  calculateTotalFinanceInfo(downPayment, 0, selectedYear);

                  return;
                }

                // Allow partial input like "1.", "0.", etc.
                const regex = /^(\d{1,3})(\.\d*)?$/;

                if (regex.test(value)) {
                  console.log('value. ', value);
                  const numericValue = parseFloat(value);

                  // Only update if value is <= 100
                  if (numericValue <= 100) {
                    setInterstRate(value); // Keep as string to preserve input
                    setIRSlider(numericValue);
                    calculateTotalFinanceInfo(downPayment, numericValue, selectedYear);
                  }
                }
              }}
            />
          </div>
        </div>
        <div className="ic-range-container">
          <div className="col-lg-6">
            <label htmlFor="ic-range-loan-term" className="ic-label">Loan Term</label>
            <input className="form-range ic-range"
              type="range"
              step={1} id="ic-range-loan-term"
              max={99}
              min={0}
              maximumTrackTintColor="paleGrey"
              value={selectedYear ? Number(selectedYear) : 0}
              onPointerUp={() => handleGAEvents("InvestmentCalculator|Finance|loanTermSlider")}
              onChange={e => {
                setCustomYear(e.target.value);
                setSelectedYear(e.target.value);
                calculateTotalFinanceInfo(downPayment, interstRate, e.target.value);
              }}
            />
          </div>
          <div className="col-lg-6">
            <CurrencyInput type="money" className="form-control ic-currency-text" placeholder=""
              aria-label="Loan term in years"
              suffix='Yr'
              numberOfLines={1}
              maxLength={2}
              returnKeyType="done"
              keyboardType={'numeric'}
              value={selectedYear?.toString()}
              includeRawValueInChangeText={true}
              onFocus={event => { }}
              onBlur={() => handleGAEvents("InvestmentCalculator|Finance|LoanTermInput")}
              onValueChange={(value, name, values) => {
                  setCustomYear(value);
                  setSelectedYear(value);
                  calculateTotalFinanceInfo(downPayment, interstRate, value);
              }}
            />
          </div>
        </div>
      </>
    )
  }
  const loadExpenseSection = () => {
    return (
      <>
        <div className="ic-range-container">
          <div className="col-lg-6">
            <label htmlFor="ic-range-maintenance" className="ic-label">Maintenance</label>
            <input className="form-range ic-range"
              type="range"
              min="0"
              max={99999}
              minimumValue={0}
              value={maintananceSlider ? Number(maintananceSlider) : 0}
              step={1}
              onPointerUp={() => handleGAEvents("InvestmentCalculator|Expenses|MaintainanceSlider")}
              onChange={e => {
                setMaintanance(e.target.value);
                setMaintananceSlider(e.target.value);
                calculateGrossExpense(e.target.value, 'maintenance');
              }}
              id="ic-range-maintenance"
            />
          </div>
          <div className="col-lg-6">
            <CurrencyInput
              className="form-control ic-currency-text"
              placeholder=""
              aria-label="Maintenance amount"
              type={'money'}
              prefix='$'
              numberOfLines={1}
              returnKeyType="done"
              maxLength={9}
              keyboardType={'numeric'}
              defaultValue={investmentData?.property_maintenance_mo?.toString()}
              includeRawValueInChangeText={true}
              value={maintanance === 0 ? '0' : maintanance}
              onBlur={() => handleGAEvents("InvestmentCalculator|Expenses|MaintainanceInput")}
              onValueChange={(value, name, values) => {
                setMaintanance(value);
                setMaintananceSlider(value);
                calculateGrossExpense(value, 'maintenance');
              }}
            />
          </div>
        </div>
        <div className="ic-range-container">
          <div className="col-lg-6">
            <label htmlFor="ic-range-hoa-fees" className="ic-label">HOA Fees</label>
            <input className="form-range ic-range"
              type="range"
              step={1} id="ic-range-hoa-fees"
              max={99999}
              min={0}
              maximumTrackTintColor="paleGrey"
              value={hoeSlider ? Number(hoeSlider) : 0}
              onPointerUp={() => handleGAEvents("InvestmentCalculator|Expenses|HoaFeeSlider")}
              onChange={e => {
                setHoeFee(e.target.value);
                setHoeSlider(e.target.value);
                calculateGrossExpense(e.target.value, 'hoeFee');
              }}
            />
          </div>
          <div className="col-lg-6">
            <CurrencyInput
              className="form-control ic-currency-text"
              placeholder=""
              aria-label="HOA fees amount"
              type={'money'}
              prefix='$'
              numberOfLines={1}
              returnKeyType="done"
              maxLength={9}
              keyboardType={'numeric'}
              includeRawValueInChangeText={true}
              value={hoeFee === 0 ? 0 : hoeFee?.toString()}
              onFocus={event => { }}
              onBlur={() => handleGAEvents("InvestmentCalculator|Expenses|HoaFeeInput")}
              onValueChange={(value, name, values) => {
                setHoeFee(value);
                setHoeSlider(value);
                calculateGrossExpense(value, 'hoeFee');
              }
              } />
          </div>
        </div>
        <div className="ic-range-container">
          <div className="col-lg-6">
            <label htmlFor="ic-range-property-management" className="ic-label">Property management</label>
            <input className="form-range ic-range"
              type="range"
              step={1} id="ic-range-property-management"
              max={99999}
              min={0}
              maximumTrackTintColor="paleGrey"
              value={propertyManagementSlider ? Number(propertyManagementSlider) : 0}
              onPointerUp={() => handleGAEvents("InvestmentCalculator|Expenses|PropertyManagementSlider")}
              onChange={e => {
                setPropertyManagement(e.target.value);
                setPropertyManagementSlider(e.target.value);
                calculateGrossExpense(e.target.value, 'management');
              }}
            />
          </div>
          <div className="col-lg-6">
            <CurrencyInput type="money" className="form-control ic-currency-text" placeholder=""
              aria-label="Property management amount"
              prefix='$'
              numberOfLines={1}
              maxLength={9}
              returnKeyType="done"
              keyboardType={'numeric'}
              value={propertyManagement === 0 ? '' : propertyManagement?.toString()}
              includeRawValueInChangeText={true}
              onFocus={event => { }}
              onBlur={() => handleGAEvents("InvestmentCalculator|Expenses|PropertyManagementInput")}
              onValueChange={(value, name, values) => {
                setPropertyManagement(value);
                setPropertyManagementSlider(value);
                calculateGrossExpense(value, 'management');
              }}
            />
          </div>
        </div>
        <div className="ic-range-container">
          <div className="col-lg-6">
            <label htmlFor="ic-range-property-taxes" className="ic-label">Property Taxes</label>
            <input className="form-range ic-range"
              type="range"
              step={1}
              id="ic-range-property-taxes"
              max={99999}
              min={0}
              maximumTrackTintColor="paleGrey"
              value={taxesSlider ? Number(taxesSlider) : 0}
              onPointerUp={() => handleGAEvents("InvestmentCalculator|Expenses|PropertyTaxSlider")}
              onChange={e => {
                setTaxes(e.target.value);
                setTaxesSlider(e.target.value);
                calculateGrossExpense(e.target.value, 'taxes');
              }}
            />
          </div>
          <div className="col-lg-6">
            <CurrencyInput type="money" className="form-control ic-currency-text" placeholder=""
              aria-label="Property taxes amount"
              prefix='$'
              numberOfLines={1}
              maxLength={9}
              returnKeyType="done"
              keyboardType={'numeric'}
              value={taxes?.toString()}
              includeRawValueInChangeText={true}
              onFocus={event => { }}
              onBlur={() => handleGAEvents("InvestmentCalculator|Expenses|PropertyTaxInput")}
              onValueChange={(value, name, values) => {
                setTaxes(value);
                setTaxesSlider(value);
                calculateGrossExpense(value, 'taxes');
              }}
            />
          </div>
        </div>
        <div className="ic-range-container">
          <div className="col-lg-6">
            <label htmlFor="ic-range-property-insurance" className="ic-label">Property Insurance</label>
            <input className="form-range ic-range"
              type="range"
              step={1}
              id="ic-range-property-insurance"
              max={99999}
              min={0}
              maximumTrackTintColor="paleGrey"
              value={insuranceSlider ? Number(insuranceSlider) : 0}
              onPointerUp={() => handleGAEvents("InvestmentCalculator|Expenses|PropertyInsuranceSlider")}
              onChange={e => {
                setInsurance(e.target.value);
                setInsuranceSlider(e.target.value);
                calculateGrossExpense(e.target.value, 'insurance');
              }}
            />
          </div>
          <div className="col-lg-6">
            <CurrencyInput type="money" className="form-control ic-currency-text" placeholder=""
              aria-label="Property insurance amount"
              prefix='$'
              numberOfLines={1}
              maxLength={9}
              returnKeyType="done"
              keyboardType={'numeric'}
              value={insurance?.toString()}
              includeRawValueInChangeText={true}
              onFocus={event => { }}
              onBlur={() => handleGAEvents("InvestmentCalculator|Expenses|PropertyInsuranceInput")}
              onValueChange={(value, name, values) => {
                setInsurance(value);
                setInsuranceSlider(value);
                calculateGrossExpense(value, 'insurance');
              }}
            />
          </div>
        </div>
      </>
    )
  }
  const loadRentalEstimateSection = () => {
    return (
      <>
        <div className="ic-monthly-rent-container mt10">
          <div className='ic-rent-container'>
            <div class="sl-title avg">
              <div class="sl-tip">{getFormattedPrice(investmentData?.rent_low_mo)}</div>
              <div class="sl-label">Min. Monthly Rent</div>
              <div class="arrow-ic">
                <img src="/assets/images/down-arrow.svg" class="arrow-down" height="8" width="16" alt="arrow" />
              </div>
            </div>
            <div class="sl-title avg">
              <div class="sl-tip">{getFormattedPrice(investmentData?.rent_med_mo)}</div>
              <div class="sl-label">Avg. Monthly Rent</div>
              <div class="arrow-ic">
                <img src="/assets/images/down-arrow.svg" class="arrow-down" height="8" width="16" alt="arrow" />
              </div>
            </div>
            <div class="sl-title avg">
              <div class="sl-tip">{getFormattedPrice(investmentData?.rent_high_mo)}</div>
              <div class="sl-label">Max. Monthly Rent</div>
              <div class="arrow-ic">
                <img src="/assets/images/down-arrow.svg" class="arrow-down" height="8" width="16" alt="arrow" />
              </div>
            </div>
          </div>
        </div>
        <div className='ic-monthly-rent-container mb40'>
          <div className='ic-slider-outer'>
            <div className='ic-slider-inner'></div>
          </div>
        </div>
        <div className="ic-range-container">
          <div className="col-lg-6">
            <label htmlFor="ic-range-rent" className="ic-label">Rent</label>
            <input className="form-range ic-range"
              type="range"
              id="ic-range-rent"
              max={investmentData?.rent_high_mo * 3}
              min={0}
              maximumTrackTintColor="paleGrey"
              value={rentAmt ? Number(rentAmt) : 0}
              onPointerUp={() => handleGAEvents("InvestmentCalculator|RentalEstimate|RentSlider")}
              onChange={e => {
                setRentAmt(e.target.value);
                setRentAmount(e.target.value);
                updateRentAmount(e.target.value);
              }}
            />
          </div>
          <div className="col-lg-6">
            <CurrencyInput
              className="form-control ic-currency-text"
              placeholder=""
              aria-label="Rent amount"
              type={'money'}
              prefix='$'
              numberOfLines={1}
              returnKeyType="done"
              maxLength={9}
              keyboardType={'numeric'}
              includeRawValueInChangeText={true}
              value={rentAmount === 0 ? 0 : rentAmount}
              onFocus={event => { }}
              onBlur={() => handleGAEvents("InvestmentCalculator|RentalEstimate|RentInput")}
              onValueChange={(value, name, values) => {
                if (!charOccurances(value, '.') > 0) {
                  setRentAmt(value);
                  setRentAmount(value);
                  updateRentAmount(value);
                }
              }}
            />
          </div>
        </div>
        <div className="ic-range-container">
          <div className="col-lg-6">
            <label htmlFor="ic-range-vacancy" className="ic-label">Vaccancy</label>
            <input className="form-range ic-range"
              type="range"
              id="ic-range-vacancy"
              max={100}
              min={0}
              maximumTrackTintColor="paleGrey"
              value={vaccyRateSlider ? Number(vaccyRateSlider) : 0}
              onPointerUp={() => handleGAEvents("InvestmentCalculator|RentalEstimate|VacancySlider")}
              onChange={e => {
                setVaccanyError(false);
                setVacancyRate(e.target.value);
                setVaccyRateSilder(e.target.value);
                updateVacancyAmount(e.target.value);
              }}
            />
          </div>
          <div className="col-lg-6 d-flex">
            <CurrencyInput type="money" className="form-control mr10 ic-currency-text" placeholder=""
              aria-label="Vacancy loss amount"
              prefix='$'
              numberOfLines={1}
              maxLength={9}
              returnKeyType="done"
              keyboardType={'numeric'}
              value={vacancyAmount === 0 ? '' : vacancyAmount}
              includeRawValueInChangeText={true}
              onFocus={event => { }}
              onBlur={() => {
                updateVacancyRate(vacancyAmount)
                handleGAEvents("InvestmentCalculator|RentalEstimate|VacancyInput")
              }}
              onValueChange={(value, name, values) => {
                setVaccanyError(false);
                setVacancyAmount(value);
                updateVacancyRate(value);
              }}
            />
            <CurrencyInput
              type="money"
              className="form-control ic-currency-text-percentage"
              placeholder=""
              aria-label="Vacancy rate percentage"
              suffix='%'
              numberOfLines={1}
              maxLength={9}
              returnKeyType="done"
              keyboardType={'numeric'}
              value={vacancyRate?.toString()}
              includeRawValueInChangeText={true}
              onFocus={event => { }}
              onBlur={() => handleGAEvents("InvestmentCalculator|RentalEstimate|VacancyPercentage")}
              onValueChange={(value, name, values) => {

                if (value === '' || value === undefined) {
                  setVacancyRate(0);
                  setVaccyRateSilder(0);
                  updateVacancyAmount(0);
                  return;
                }

                // Allow partial input like "1.", "0.", etc.
                const regex = /^(\d{1,3})(\.\d*)?$/;

                if (regex.test(value)) {

                  const numericValue = parseFloat(value);

                  // Only update if value is <= 100
                  if (numericValue <= 100) {
                    setVacancyRate(value);
                    setVaccyRateSilder(value);
                    updateVacancyAmount(value);
                  }
                }
              }}
            />
          </div>
        </div>
        <div class="rent-range-info">
          <div class="row">
            <div class="col-xs-12">
              Rent Estimates based on 60 comparable rental properties in a 1 mi radius
            </div>
            <div class="col-xs-12 logo-holder">
              <div class="rent-range-site">Rental data provided by
                <a href="https://www.rentrange.com" target="_blank" title="Rent Range website" aria-label="Rent Range website link" class="log-ga-action rent-range-logo" onClick={() => handleGAEvents("Rent Range website link Click")}></a>
              </div>
              <div>
                <button class="rent-range-disclaimer log-ga-action" aria-label="Rent Range Disclaimer" onClick={() => {
                  setShowBanner(true)
                  handleGAEvents("Rent Range Disclaimer Click")
                }}>Disclaimer</button>
              </div>
            </div>
          </div>
        </div>
      </>
    )
  }
  const loadPurchaseSection = () => {
    return (
      <>
        <div className="ic-range-container">
          <div className="col-lg-6 ic-md">
            <label htmlFor="ic-range-offer-amount" className="ic-label">Offer Amount</label>
            <input className="form-range ic-range"
              type="range"
              min="0"
              max={initialOfferP ? initialOfferP * 3 : 9999}
              step={100}
              value={offerPSlider ? Number(offerPSlider) : 0}
              onPointerUp={() => handleGAEvents("InvestmentCalculator|Purchase|OfferAmountSlider")}
              onChange={e => {
                setOfferPSlider(e.target.value);
                updatePurchaseData(e.target.value);
              }}
              id="ic-range-offer-amount">
            </input>
          </div>
          <div className="col-lg-6">
            <CurrencyInput type="money" className="form-control ic-currency-text" placeholder=""
              aria-label="Offer amount"
              prefix="$"
              numberOfLines={1}
              maxLength={9}
              returnKeyType="done"
              keyboardType={'numeric'}
              value={purchasePrice === 0 ? '' : purchasePrice}
              includeRawValueInChangeText={true}
              onFocus={event => { }}
              onBlur={() => handleGAEvents("InvestmentCalculator|Purchase|OfferAmountInput")}
              onValueChange={(value, name, values) => {
                setOfferPrice(value ? value : 0);
                setOfferPSlider(value ? value : 0);
                updatePurchaseData(value ? value : 0);
              }}
            />
          </div>
        </div>
        <div className="ic-range-container">
          <div className="col-lg-6">
            <label htmlFor="ic-range-rehab-cost" className="ic-label">Rehab Cost</label>
            <input className="form-range ic-range"
              type="range"
              step={1} id="ic-range-rehab-cost"
              max={100}
              min={0}
              maximumTrackTintColor="paleGrey"
              value={rehabValSlider ? Number(rehabValSlider) : 0}
              onPointerUp={() => handleGAEvents("InvestmentCalculator|Purchase|RehabPriceSlider")}
              onChange={e => {
                setRehabValSlider(e.target.value);
                setRehabPercentage(e.target.value);
                calculateRehabValue(e.target.value);
              }}
            />

          </div>
          <div className="col-lg-6 d-flex">
            <CurrencyInput
              className="form-control mr10 ic-currency-text"
              placeholder=""
              aria-label="Rehab cost amount"
              type={'money'}
              prefix="$"
              numberOfLines={1}
              returnKeyType="done"
              maxLength={9}
              keyboardType={'numeric'}
              includeRawValueInChangeText={true}
              value={rehabVal === 0 ? '0' : rehabVal}
              onFocus={event => {
              }}
              onBlur={() => handleGAEvents("InvestmentCalculator|Purchase|RehabPriceInput")}
              onValueChange={(value, name, values) => {
                setRehabVal(value);
                calculateRehabPercentage(value);
                if (value > offerPrice) {
                  setClosingCostError(true);
                } else {
                  setClosingCostError(false);
                }

              }}
            />

            <CurrencyInput
              type="text"
              className="form-control ic-currency-text-percentage"
              placeholder=""
              aria-label="Rehab cost percentage"
              keyboardType="numeric"
              returnKeyType="done"
              underlineColorAndroid="transparent"
              placeholderTextColor="#85929e"
              value={rehabPercentage?.toString()}
              maxLength={4}
              suffix='%'
              onBlur={() => handleGAEvents("InvestmentCalculator|Purchase|RehabPricePercentage")}
              onValueChange={(value, name, values) => {
                // Allow empty string so user can delete
                if (value === '' || value === undefined) {
                  setRehabPercentage(0);
                  setRehabValSlider(0);
                  calculateRehabValue(0);
                  return;
                }

                // Allow partial input like "1.", "0.", etc.
                const regex = /^(\d{1,3})(\.\d*)?$/;

                if (regex.test(value)) {

                  const numericValue = parseFloat(value);

                  // Only update if value is <= 100
                  if (numericValue <= 100) {
                    setRehabPercentage(value);
                    setRehabValSlider(value);
                    calculateRehabValue(value);
                  }
                }




              }}
            />

          </div>

        </div>
        <div className="col-lg-6 d-flex" style={{ paddingLeft: '50%', width: '100%' }}>
          {closingCostError === true && (
            <p className='error-generic'>Amount should be less than offer amount</p>
          )}

        </div>

        <div className="ic-range-container">
          <div className="col-lg-6">
            <label htmlFor="ic-range-closing-cost" className="ic-label">Closing Cost</label>
            <input className="form-range ic-range"
              type="range"
              step={1} id="ic-range-closing-cost"
              max={100}

              min={0}
              maximumTrackTintColor="paleGrey"
              value={closingCSlider ? Number(closingCSlider) : 0}
              onPointerUp={() => handleGAEvents("InvestmentCalculator|Purchase|ClosingCostSlider")}
              onChange={e => {
                setClosingCSlider(e.target.value);
                calculateClosingCost(e.target.value);
              }}
            />
          </div>
          <div className="col-lg-6 d-flex">
            <CurrencyInput
              className="form-control mr10 ic-currency-text"
              placeholder=""
              aria-label="Closing cost amount"
              type={'money'}
              options={{
                precision: 0,
                separator: '.',
                delimiter: ',',
                unit: '$',
                suffixUnit: '',
              }}
              prefix="$"
              numberOfLines={1}
              maxLength={9}
              returnKeyType="done"
              keyboardType={'numeric'}
              value={closingCost}
              includeRawValueInChangeText={true}
              onBlur={() => handleGAEvents("InvestmentCalculator|RentPurchaselEstimate|ClosingCostInput")}
              onValueChange={(value, name, values) => {
                setClosingCost(value);
                if (value > offerPrice) {
                  setClosingCostError(true);
                } else {
                  setClosingCostError(false);
                }
                calculateClosingCostPercentage(value);
              }}
            />

            <CurrencyInput type="text"
              className="form-control ic-currency-text-percentage"
              placeholder=""
              aria-label="Closing cost percentage"
              keyboardType="numeric"
              returnKeyType="done"
              underlineColorAndroid="transparent"
              placeholderTextColor="#85929e"
              value={closingCostPercentage?.toString()}
              maxLength={4}
              suffix="%"
              onBlur={() => handleGAEvents("InvestmentCalculator|Purchase|ClosingCostPercentage")}
              onValueChange={(value, name, values) => {
                if (value === '' || value === undefined) {
                  setClosingCostPercentage(0);
                  setClosingCSlider(0);
                  calculateClosingCost(0);
                  return;
                }

                // Allow partial input like "1.", "0.", etc.
                const regex = /^(\d{1,3})(\.\d*)?$/;

                if (regex.test(value)) {

                  const numericValue = parseFloat(value);

                  // Only update if value is <= 100
                  if (numericValue <= 100) {
                    setClosingCostPercentage(value);
                    setClosingCSlider(value);
                    calculateClosingCost(value);
                  }
                }
              }} />
          </div>
        </div>

      </>


    )


  }
  const loadDetailCalculation = () => {
    return (
      <div className="row">
        <div className="container">
          <div className={`ic-results ${selectedTab === 'Purchase' ? 'active' : ''}`}>
            <div className="ic-row">
              <div className='ic-out-label'>Capital Investment</div>
              <div className='ic-out-amount'>{getFormattedPrice(capitalInvestment)}</div>
            </div>
            <div className="ic-row">
              <div className='ic-out-label'>Needed at Closing</div>
              <div className='ic-out-amount'>{getFormattedPrice(needClosingAT)}</div>
            </div>
          </div>
          {selectedTab === 'Purchase' && <div className='ic-arrow-left' />}
          <div className={`ic-results ${selectedTab === 'Financing' ? 'active' : ''}`}>
            <div className="ic-row">
              <div className='ic-out-label'>Total Financed</div>
              <div className='ic-out-amount'>{getFormattedPrice(financeTotal)}</div>
            </div>
            <div className="ic-row">
              <div className='ic-out-label'>Monthly Payment</div>
              <div className='ic-out-amount'>{getFormattedPrice(monthlyPayment)}</div>
            </div>
          </div>
          {selectedTab === 'Financing' && <div className='ic-arrow-left' />}
          <div className={`ic-results ${selectedTab === 'Expenses' ? 'active' : ''}`}>
            <div className="ic-row">
              <div className='ic-out-label'>Monthly Expenses</div>
              <div className='ic-out-amount'>{getFormattedPrice(monthlyExpense)}</div>
            </div>
            <div className="ic-row">
              <div className='ic-out-label'>Yearly Expenses</div>
              <div className='ic-out-amount'>{getFormattedPrice(yearlyExpenses)}</div>
            </div>
          </div>
          {selectedTab === 'Expenses' && <div className='ic-arrow-left' />}
          <div className={`ic-results ${selectedTab === 'Rental Estimate' ? 'active' : ''}`}>
            <div className="ic-row">
              <div className='ic-out-label'>Monthly Income</div>
              <div className='ic-out-amount'>{getFormattedPrice(monthlyIncome)}</div>
            </div>
            <div className="ic-row">
              <div className='ic-out-label'>Yearly Income</div>
              <div className='ic-out-amount'>{getFormattedPrice(yearlyIncome)}</div>
            </div>
          </div>
          {selectedTab === 'Rental Estimate' && <div className='ic-arrow-left' />}
        </div>
      </div>
    )
  }
  const loadInvestability = () => {
    return (
      <div className="d-flex flex-column flex-xl-row order-2 order-xl-1">
        <div class="col-12 col-xl-8">
          <p className="ic-desc">
            * The investment calculator and its calculations are for information purposes only. You acknowledge that
            these are estimates only and that (a) there are uncertainties inherent in making such estimates,
            forecasts,
            plans and projections and that you are familiar with such uncertainties, and (b) You will take full
            responsibility for conducting your own evaluation of the adequacy and accuracy of such estimates,
            forecasts,
            plans and projections and (c) You shall have no Claim against Altisource and its affiliates with respect
            to
            such estimates, forecasts, plans or projections. Accordingly, Altisource and its affiliates are making
            no
            representation or warranty with respect to such estimates, forecasts,
            plans and projections (including such underlying assumptions).
          </p>
        </div>
        <div class="col-12 col-xl-4">
          <div className="propertyInfoBox mb30 p0 mt20 ml10 mr10">
            <Row className="propertyInfoBoxHeading p0 ic-invest-header">
              <h3 className='propertyInfoBoxHeadingText ic-invest-text'>INVESTABILITY*</h3>
            </Row>
            <div className="list-unstyled pl20 pr20">
              <div className="ic-invest-container">
                <div className='ic-out-label'>Gross yield</div>
                <div className='ic-out-amount'>{grossYield === 'Infinity' ? '-' : grossYield + '%'}</div>
              </div>
              <div className="ic-invest-container">
                <div className='ic-out-label'>Monthly Cash Flow</div>
                <div className='ic-out-amount'>{monthlyCasFlow === 'Infinity' ? '-' : getFormattedPrice(monthlyCasFlow)}</div>
              </div>
              <div className="ic-invest-container pb15">
                <div className='ic-out-label'>Net Yield</div>
                <div className='ic-out-amount'>{netYield === 'Infinity' ? '-' : netYield + '%'}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
  tempSetData();
  return (
    <div className="">
      <div className=" propertyInfoBox mb30 p0">
        <Row className="propertyInfoBoxHeading p0">
          <h3 className='propertyInfoBoxHeadingText'>Investment Calculator</h3>
        </Row>
        <div className="container-xl  pt20">
          <div className="d-flex flex-column flex-xl-row">
            <div className="col-12 col-xl-2 d-flex flex-column mb-3 mb-xl-0">
              {['Purchase', 'Financing', 'Expenses', 'Rental Estimate'].map((tabName) => (
                <div className='m0'>
                  <div
                    className={`ic-nav-link ${selectedTab === tabName ? 'active' : ''}`}
                    onClick={() => {
                      setSelectedTab(tabName)
                      trackButtonClick({
                        eventName: "investment_calculator_tab_click",
                        eventCategory: "NEW-PDP",
                        eventParams: {
                          tab: tabName.replace(/\s+/g, "_").toLowerCase(),
                        },
                      })
                    }}
                  >
                    {tabName}
                  </div>
                  {selectedTab === tabName && <div className='ic-arrow-right' />}
                </div>
              ))}
            </div>
            <div className="col-12 col-xl-6 mb-3 mb-xl-0">
              <div className="tab-content" id="myTabContent">
                <div className={`tab-pane fade ${selectedTab === 'Purchase' ? 'show active' : ''}`}>{loadPurchaseSection()}</div>
                <div className={`tab-pane fade ${selectedTab === 'Financing' ? 'show active' : ''}`}>{loadFinancigSection()}</div>
                <div className={`tab-pane fade ${selectedTab === 'Expenses' ? 'show active' : ''}`}>{loadExpenseSection()}</div>
                <div className={`tab-pane fade ${selectedTab === 'Rental Estimate' ? 'show active' : ''}`}>{loadRentalEstimateSection()}</div>
              </div>
            </div>
            <div className="col-12 col-xl-4">
              {loadDetailCalculation()}
            </div>
          </div>
          <div>
            {loadInvestability()}
          </div>
        </div>
      </div>
      <DisclaimerModal showBanner={showBanner} setShowBanner={setShowBanner} />
    </div>
  )
}

export default InvestmentCalculator;